import { css } from '@emotion/css';
import classNames from 'classnames';
import globalStyle from 'constants/global.style';
import { colors } from 'constants/theme';
import { InfoPaginate } from 'models/commonModel';
import { LotteryRecord } from 'models/lotteryModel';
import moment from 'moment';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa6';
import { HiOutlineRefresh } from 'react-icons/hi';
const bgTitleLinear = `${colors.lottery}`;

interface Props {
    recordList: LotteryRecord[];
    infoPage: InfoPaginate | null;
    onChangePage: (page: string) => void;
    onShowDetailRecord: (recordId: string) => void;
}
function LotteryHistoryTable(props: Props) {
    const { recordList, infoPage, onChangePage, onShowDetailRecord } = props;

    const formatCodeString = (codes: string) => {
        if (codes) {
            return codes.replace(/&/g, ',');
        }
        return '';
    };

    const handleChangePage = (pav: string) => {
        onChangePage(pav);
    };

    const refreshPage = () => {
        onChangePage('btnSearch');
    };

    return (
        <section className={styles.wrap}>
            <div className={styles.heading}>
                <h4>Lịch sử cược</h4>
                <button type="button" className={styles.btnClearAll} onClick={refreshPage}>
                    <HiOutlineRefresh size={20} />
                </button>
            </div>
            <div className={styles.table}>
                <div className={styles.row}>
                    <div className={`${styles.col} ${styles.title}`}>Lượt xổ</div>
                    <div className={`${styles.col} ${styles.title}`}>Xổ số</div>
                    <div className={`${styles.col} ${styles.title}`}>Kiểu cược</div>
                    <div className={`${styles.col} ${styles.title}`}>Thời gian cược</div>
                    <div className={`${styles.col} ${styles.title} ${styles.codesBet}`}>Số cược</div>
                    <div className={`${styles.col} ${styles.title}`}>Tiền cược</div>
                    <div className={`${styles.col} ${styles.title}`}>Tình trạng</div>
                </div>
                {recordList.length > 0 ? (
                    recordList.map((item) => (
                        <div className={styles.row} key={item.id} onClick={() => onShowDetailRecord(item.id)}>
                            <p className={`${styles.col}`}>{item.issue}</p>
                            <p className={`${styles.col} ${globalStyle.text.blue}`}>{item.lotteryName}</p>
                            <p className={`${styles.col}`}>{item.lotteryMethod}</p>
                            <p className={`${styles.col}`}>{moment(item.bettime).format('DD/MM/yyyy HH:mm:ss')}</p>
                            <p className={`${styles.col} ${styles.codesBet}`}>{formatCodeString(item.codes)}</p>
                            <p className={styles.col}> {new Intl.NumberFormat().format(item.amount)}</p>
                            <p className={classNames(styles.col, item.status === 'Trúng' && globalStyle.text.success, item.status === 'Trượt' && globalStyle.text.error)}>{item.status}</p>
                        </div>
                    ))
                ) : (
                    <div className={styles.noData}>
                        <p>Không có dữ liệu</p>
                    </div>
                )}
            </div>
            {infoPage && infoPage.totalpage > 1 && (
                <div className={styles.pagination}>
                    <button onClick={(() => handleChangePage("proPage"))}>
                        <FaArrowLeft size={18} color='red' /></button>
                    <button onClick={(() => handleChangePage("nextPage"))}>
                        <FaArrowRight color='red' size={18} />
                    </button>
                    <p>Total: {infoPage.totalpage}</p>
                </div>
            )}
        </section>
    );
}

const styles = {
    wrap: css`
        padding-top: 16px;
    `,
    pagination: css`
        display: flex;
        margin-top: 20px;
        align-items: center;
        button {
            cursor: pointer;
            box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.4);
            color: #fff;
            padding: 3px 10px;
            margin-right: 10px;
            border-radius: 5px;
            &:hover {
                background: linear-gradient(to bottom, #1b53f0, #011e98);
            }
        }
    `,
    heading: css`
        background: ${bgTitleLinear};
        color: ${colors.white};
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 6px 16px;
        border-radius: 8px;
        margin-bottom: 16px;
    `,
    ticketLabel: css`
        background: ${colors.red};
        border-radius: 40px;
        font-size: 14px;
        padding: 4px 8px;
        display: inline-block;
        margin-left: 6px;
    `,
    btnClearAll: css`
        border: 1px solid ${colors.lightBlue};
        border-radius: 8px;
        padding: 6px;
        font-size: 14px;
        color: ${colors.white};
        display: flex;
    `,
    table: css`
        border: 1px solid ${colors.lightBlue};
        border-radius: 8px;
        overflow: hidden;
        min-height: 150px;
        &.table-col-center {
            .col {
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
    `,
    codesBet: css`
        word-wrap: break-word;
        max-width: 200px;
        flex: 0 0 200px;
    `,
    row: css`
        display: flex;
        border-bottom: 1px solid ${colors.lightBlue};
        cursor: pointer;
        &:first-child {
            border-bottom-color: ${colors.lightBlue};
        }
        &:last-child {
            border-bottom: none;
        }
        &:hover {
            background: #f0f7ff;
        }
    `,
    col: css`
        flex: 1;
        padding: 12px 8px;
        text-align: center;
        font-size: 14px;
    `,
    title: css`
        font-weight: 600;
        background: #f0f7ff;
    `,
    noData: css`
        text-align: center;
        padding: 30px;
        p {
            margin-top: 8px;
            font-size: 14px;
        }
    `,
    btnRemoveTicket: css`
        width: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        img {
            height: 16px;
        }
    `,
};

export default LotteryHistoryTable;
